import React from 'react';
import T from 'i18n-react';

import { func } from 'prop-types';
import { Button } from '@adsk/bim360-matrix-react-components';

const AddDocumentButton = ({ onClick }) => {
  const textPlaceholderLinkToDocument = T.translate('new.placeholder.linkToDocument');
  const textLinkToDocumentAction = T.translate('new.placeholder.linkToDocumentAction');
  const dash = ' - ';
  return (
    <div className="LinkToDocumentField__placeholder">
      <label>{textPlaceholderLinkToDocument + dash}</label>
      <Button styleType={Button.StyleType.INLINE_LINK} onClick={onClick}>
        {textLinkToDocumentAction}
      </Button>
    </div>
  );
};

AddDocumentButton.propTypes = {
  onClick: func.isRequired,
};

export default AddDocumentButton;
